import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import SyncIntervalMultiple from '@databox/ember-integrations/lib/components/DataSourceSyncIntervalMultiple/DataSourceSyncIntervalMultiple';
import { create } from '@databox/ember-integrations/lib/components/Setup';

import type { PopupData, ReactIntegrations, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class SourcePopupEnablePriorityDataUpdateComponent extends PopupInnerModalComponent<PopupData.Source.EnableCustomDataUpdate> {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('react') declare reactService: Service.React;

	contentNode: ReactIntegrations.Root = null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.analyticsService.event(TrackingEvent.DATA_PRIORITY_UPDATE_POPUP_OPENED, {
			origin: this.popupData.trackingOrigin,
			datasources: this.popupData.dataSources.map(
				(dataSource) => dataSource.dataSourceTypeName,
			),
		});
	}

	get isLimitReached() {
		return this.popupData.isLimitReached;
	}

	@action
	setupView(node: HTMLElement) {
		this.contentNode = create(node as HTMLDivElement);

		const newProps: PopupData.Source.EnableCustomDataUpdate = {
			...this.popupData,
			onRenderEnd: () => {
				this.reposition();
			},
		};

		this.reactService.render(this.contentNode, SyncIntervalMultiple(newProps));
	}

	@action
	teardownView(): void {
		if (this.contentNode) {
			this.contentNode.unmount();
			this.contentNode = null;
		}
	}
	<template>
		<div class="content">
			<div class="header">
				<CommonUiIconComponent @name="Refresh" @size="2xl" @class="header-icon" />
				<h2>Enable faster sync frequency</h2>
			</div>

			<hr />

			<p class="subtitle">
				{{#if this.isLimitReached}}
					<strong>You've reached the daily limit of manual data updates.</strong><br />
				{{/if}}
				Add a faster sync frequency to your subscription for data sources used on this
				dashboard.
			</p>

			<p class="table-title">
				Used data sources on this dashboard:
			</p>
		</div>

		<div {{didInsert this.setupView}} {{willDestroy this.teardownView}}></div>
	</template>
}
